module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("机侧题库")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("试做试卷")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search mex-search"
  }, [_c('Form', {
    attrs: {
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "考试类型"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择考试类型"
    },
    model: {
      value: (_vm.form.examType),
      callback: function($$v) {
        _vm.$set(_vm.form, "examType", $$v)
      },
      expression: "form.examType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "PLACEMENT"
    }
  }, [_vm._v("入门测")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "SUMMATIVE"
    }
  }, [_vm._v("阶段测")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "出生年"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "年"
    },
    model: {
      value: (_vm.form.birthYear),
      callback: function($$v) {
        _vm.$set(_vm.form, "birthYear", $$v)
      },
      expression: "form.birthYear"
    }
  }, _vm._l((_vm.birthYears), function(y) {
    return _c('Option', {
      key: 'by' + y,
      attrs: {
        "value": y
      }
    }, [_vm._v(_vm._s(y) + " 年")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "出生月"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "月"
    },
    model: {
      value: (_vm.form.birthMonth),
      callback: function($$v) {
        _vm.$set(_vm.form, "birthMonth", $$v)
      },
      expression: "form.birthMonth"
    }
  }, _vm._l((12), function(m) {
    return _c('Option', {
      key: 'bm' + m,
      attrs: {
        "value": m
      }
    }, [_vm._v(_vm._s(m) + " 月")])
  }), 1)], 1)], 1), _vm._v(" "), (_vm.form.examType === 'PLACEMENT') ? _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "宝贝目前的英语水平"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "与 App 探险证同一套五档"
    },
    model: {
      value: (_vm.form.selfLevel),
      callback: function($$v) {
        _vm.$set(_vm.form, "selfLevel", $$v)
      },
      expression: "form.selfLevel"
    }
  }, [_c('Option', {
    attrs: {
      "value": "ZERO"
    }
  }, [_vm._v("基本零基础")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "BEGINNER"
    }
  }, [_vm._v("刚入门")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "BASIC"
    }
  }, [_vm._v("有基础")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "GOOD"
    }
  }, [_vm._v("挺不错")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "FLUENT"
    }
  }, [_vm._v("很熟练")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.examType === 'SUMMATIVE') ? _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "当前课程级别"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "与学生当前级别一致"
    },
    model: {
      value: (_vm.form.courseLevel),
      callback: function($$v) {
        _vm.$set(_vm.form, "courseLevel", $$v)
      },
      expression: "form.courseLevel"
    }
  }, _vm._l((_vm.courseLevels), function(lv) {
    return _c('Option', {
      key: lv,
      attrs: {
        "value": lv
      }
    }, [_vm._v(_vm._s(lv))])
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "抽题方式"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择抽题方式"
    },
    model: {
      value: (_vm.form.shuffle),
      callback: function($$v) {
        _vm.$set(_vm.form, "shuffle", $$v)
      },
      expression: "form.shuffle"
    }
  }, [_c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("按权重从高到低（接近引擎）")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("随机（方便多抽几套）")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mex-search-actions"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.drawing
    },
    on: {
      "click": _vm.drawBlueprint
    }
  }, [_vm._v("开始抽题")]), _vm._v(" "), _c('Button', {
    attrs: {
      "loading": _vm.drawing
    },
    on: {
      "click": function($event) {
        return _vm.drawWalk('TYPES')
      }
    }
  }, [_vm._v("试做所有题型")]), _vm._v(" "), _c('Button', {
    attrs: {
      "loading": _vm.drawing
    },
    on: {
      "click": function($event) {
        return _vm.drawWalk('ALL')
      }
    }
  }, [_vm._v("做所有题目")]), _vm._v(" "), (_vm.paper) ? _c('Button', {
    on: {
      "click": _vm.resetPaper
    }
  }, [_vm._v("清空本套")]) : _vm._e(), _vm._v(" "), (_vm.paper && _vm.paper.sessionId) ? _c('Button', {
    on: {
      "click": _vm.goSession
    }
  }, [_vm._v("查看场次记录")]) : _vm._e(), _vm._v(" "), (_vm.paper && _vm.paper.sessionId && (_vm.report || _vm.paper.sessionStatus === 'READY')) ? _c('Button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.loadReport
    }
  }, [_vm._v("查看模拟报告")]) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("「开始抽题」按蓝图抽一套。「试做所有题型」每种呈现形态一道。「做所有题目」通刷该考试类型已上线全库，题量会很多。")])], 1)], 1), _vm._v(" "), (_vm.paper && _vm.paper.warnings && _vm.paper.warnings.length) ? _c('Alert', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, _vm._l((_vm.paper.warnings), function(w, i) {
    return _c('p', {
      key: 'w' + i
    }, [_vm._v(_vm._s(w))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.paper) ? _c('div', {
    staticClass: "mex-trial-explain"
  }, [_c('h3', [_vm._v("抽题规则")]), _vm._v(" "), _c('ol', _vm._l(((_vm.paper.rules || [])), function(r, i) {
    return _c('li', {
      key: 'rule' + i
    }, [_vm._v(_vm._s(r))])
  }), 0), _vm._v(" "), _c('h3', [_vm._v("使用的蓝图")]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.bpColumns,
      "data": _vm.paper.blueprints || [],
      "size": "small"
    }
  }), _vm._v(" "), (!_vm.isWalkPaper) ? [_c('h3', [_vm._v("槽位对照")]), _vm._v(" "), _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("橙色行＝应抽不足；浅黄行＝已放宽 exam_scene/级别。业务键可回题库核对。")]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.traceColumns,
      "data": _vm.paper.traces || [],
      "size": "small",
      "row-class-name": _vm.traceRowClass
    }
  })] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.paper && _vm.prepVisible) ? _c('div', {
    staticClass: "mex-trial-phone-wrap"
  }, [_c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("以下按《机考全流程设计规范 v2.5》模拟 App 测试前准备，通过后才进入答题。")]), _vm._v(" "), _c('div', {
    staticClass: "mex-trial-phone"
  }, [_c('div', {
    staticClass: "mex-trial-phone-bar"
  }, [_vm._v("迷雾森林 · 松鼠松果大冒险")]), _vm._v(" "), (_vm.prepStep === 'consent') ? _c('div', {
    staticClass: "mex-trial-phone-body"
  }, [_c('h3', [_vm._v("欢迎来到迷雾森林")]), _vm._v(" "), _c('p', [_vm._v("请让孩子独立答题，不要提示或帮忙。")]), _vm._v(" "), _c('p', [_vm._v("请保持环境安静，测试时不要打扰。")]), _vm._v(" "), _c('p', [_vm._v("请仅协助操作设备，不干预答题过程。")]), _vm._v(" "), _c('p', [_vm._v("请保证结果真实，匹配适合的学习内容。")]), _vm._v(" "), _c('Checkbox', {
    model: {
      value: (_vm.prep.agreed),
      callback: function($$v) {
        _vm.$set(_vm.prep, "agreed", $$v)
      },
      expression: "prep.agreed"
    }
  }, [_vm._v("我已阅读并同意以上公约，以及《用户隐私政策》《儿童个人信息保护规则》")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "long": "",
      "disabled": !_vm.prep.agreed,
      "loading": _vm.preparing
    },
    on: {
      "click": function($event) {
        return _vm.submitPrep('CONSENT')
      }
    }
  }, [_vm._v("同意并开始")])], 1) : _vm._e(), _vm._v(" "), (_vm.prepStep === 'profile') ? _c('div', {
    staticClass: "mex-trial-phone-body"
  }, [_c('h3', [_vm._v("领取你的森林探险证")]), _vm._v(" "), _c('p', [_vm._v("填写年龄可以帮助我们更准确地匹配题目难度")]), _vm._v(" "), _c('p', [_vm._v("出生年月")]), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Select', {
    attrs: {
      "disabled": "",
      "placeholder": "年"
    },
    model: {
      value: (_vm.prep.birthYear),
      callback: function($$v) {
        _vm.$set(_vm.prep, "birthYear", $$v)
      },
      expression: "prep.birthYear"
    }
  }, _vm._l((_vm.birthYears), function(y) {
    return _c('Option', {
      key: y,
      attrs: {
        "value": y
      }
    }, [_vm._v(_vm._s(y) + " 年")])
  }), 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Select', {
    attrs: {
      "disabled": "",
      "placeholder": "月"
    },
    model: {
      value: (_vm.prep.birthMonth),
      callback: function($$v) {
        _vm.$set(_vm.prep, "birthMonth", $$v)
      },
      expression: "prep.birthMonth"
    }
  }, _vm._l((12), function(m) {
    return _c('Option', {
      key: m,
      attrs: {
        "value": m
      }
    }, [_vm._v(_vm._s(m) + " 月")])
  }), 1)], 1)], 1), _vm._v(" "), (_vm.paper.examType === 'PLACEMENT') ? [_c('p', {
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_vm._v("宝贝目前的英语水平")]), _vm._v(" "), _c('Select', {
    attrs: {
      "disabled": "",
      "placeholder": "已按此档抽卷"
    },
    model: {
      value: (_vm.prep.selfLevel),
      callback: function($$v) {
        _vm.$set(_vm.prep, "selfLevel", $$v)
      },
      expression: "prep.selfLevel"
    }
  }, [_c('Option', {
    attrs: {
      "value": "ZERO"
    }
  }, [_vm._v("基本零基础")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "BEGINNER"
    }
  }, [_vm._v("刚入门")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "BASIC"
    }
  }, [_vm._v("有基础")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "GOOD"
    }
  }, [_vm._v("挺不错")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "FLUENT"
    }
  }, [_vm._v("很熟练")])], 1), _vm._v(" "), _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("已按此档抽卷，准备流里不能再改档位。")])] : _c('p', {
    staticClass: "mex-dim-hint",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_vm._v("阶段测按当前课程级别 " + _vm._s(_vm.paper.courseLevel) + " 抽卷，不填英语自评。")]), _vm._v(" "), _c('Checkbox', {
    staticStyle: {
      "margin-top": "12px"
    },
    model: {
      value: (_vm.prep.profileAgreed),
      callback: function($$v) {
        _vm.$set(_vm.prep, "profileAgreed", $$v)
      },
      expression: "prep.profileAgreed"
    }
  }, [_vm._v("同意使用以上信息提供测评服务，仅用于匹配题目难度，不会对外公开")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "long": "",
      "disabled": !_vm.prep.profileAgreed,
      "loading": _vm.preparing
    },
    on: {
      "click": function($event) {
        return _vm.submitPrep('PROFILE')
      }
    }
  }, [_vm._v("下一步")])], 2) : _vm._e(), _vm._v(" "), (_vm.prepStep === 'audio') ? _c('div', {
    staticClass: "mex-trial-phone-body"
  }, [_c('h3', [_vm._v("先试试你的探险耳机")]), _vm._v(" "), _c('p', [_vm._v("点击播放，听听小松鼠说话。如果能清楚听到声音，就可以继续。")]), _vm._v(" "), _c('Button', {
    attrs: {
      "long": ""
    },
    on: {
      "click": _vm.playAudio
    }
  }, [_vm._v("▶ 播放测试音频")]), _vm._v(" "), _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("如果声音太小或太大，可以调整设备音量")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "long": "",
      "disabled": !_vm.prep.audioPlayed,
      "loading": _vm.preparing
    },
    on: {
      "click": function($event) {
        return _vm.submitPrep('AUDIO')
      }
    }
  }, [_vm._v("听得到，下一步")])], 1) : _vm._e(), _vm._v(" "), (_vm.prepStep === 'mic') ? _c('div', {
    staticClass: "mex-trial-phone-body"
  }, [_c('h3', [_vm._v("再试试你的魔法麦克风")]), _vm._v(" "), _c('p', [_vm._v("点击后 3 秒倒计时，再说一句 Hello, squirrel! 会自动录 3 秒并回听。")]), _vm._v(" "), (_vm.prep.micHint) ? _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v(_vm._s(_vm.prep.micHint))]) : _vm._e(), _vm._v(" "), _c('Button', {
    attrs: {
      "long": "",
      "disabled": _vm.prep.micBusy
    },
    on: {
      "click": _vm.startMic
    }
  }, [_vm._v("开始录音调试")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "long": "",
      "disabled": !_vm.prep.micOk,
      "loading": _vm.preparing
    },
    on: {
      "click": function($event) {
        return _vm.submitPrep('MIC')
      }
    }
  }, [_vm._v("没问题，开始探险")])], 1) : _vm._e(), _vm._v(" "), (_vm.prepStep === 'loading') ? _c('div', {
    staticClass: "mex-trial-phone-body"
  }, [_c('h3', [_vm._v("正在准备森林探险...")]), _vm._v(" "), _c('Progress', {
    attrs: {
      "percent": _vm.prep.loadPct,
      "stroke-width": 12
    }
  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.paper && _vm.inExam) ? _c('div', {
    staticClass: "mex-trial-wrap"
  }, [_c('div', {
    staticClass: "mex-trial-nav"
  }, [_c('p', [_vm._v("蓝图 " + _vm._s(_vm.paper.blueprintVersion) + " · " + _vm._s(_vm.segmentLabel(_vm.paper.segment)) + " · 限时 " + _vm._s(_vm.paper.durationSec || '—') + " 秒 · 场次 " + _vm._s(_vm.paper.sessionId) + " · 共 " + _vm._s(_vm.items.length) + " 题 · 已做 " + _vm._s(_vm.doneCount) + " · 得分 " + _vm._s(_vm.totalGot) + " / " + _vm._s(_vm.totalFull))]), _vm._v(" "), _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("提交本题会写入场次记录（可回放）；不计入题目曝光统计。「下一题」若还没交会先提交再跳。")]), _vm._v(" "), _c('div', {
    staticClass: "mex-trial-dots"
  }, _vm._l((_vm.items), function(it) {
    return _c('span', {
      key: it.seq,
      staticClass: "mex-trial-dot",
      class: _vm.dotClass(it),
      on: {
        "click": function($event) {
          return _vm.go(it.seq - 1)
        }
      }
    }, [_vm._v(_vm._s(it.seq))])
  }), 0), _vm._v(" "), (_vm.showGuide) ? _c('div', {
    staticClass: "mex-trial-guide",
    on: {
      "click": function($event) {
        _vm.showGuide = false
      }
    }
  }, [_vm._v("认真做题就能收集金色松果哦！不会做的题可以点「跳过」，加油！")]) : _vm._e()]), _vm._v(" "), (_vm.current) ? _c('div', {
    staticClass: "mex-trial-card"
  }, [_c('p', {
    staticClass: "mex-trial-meta"
  }, [_vm._v("\n        第 " + _vm._s(_vm.current.seq) + " 题 · " + _vm._s(_vm.skillLabel(_vm.current.skill)) + " · " + _vm._s(_vm.current.questionType) + " · " + _vm._s(_vm.current.businessCode) + " · " + _vm._s(_vm.catReasonLabel(_vm.current.catReason)) + " · 满分 " + _vm._s(_vm.current.fullScore || 1) + "\n      ")]), _vm._v(" "), (_vm.current.issues && _vm.current.issues.length) ? _c('Alert', {
    attrs: {
      "type": "error",
      "show-icon": ""
    }
  }, [_vm._v("\n        题目可能有错：" + _vm._s(_vm.current.issues.join('；')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.current.instructionCn) ? _c('p', [_c('b', [_vm._v("中文指令")]), _vm._v(" " + _vm._s(_vm.current.instructionCn))]) : _vm._e(), _vm._v(" "), (_vm.current.instructionEn) ? _c('p', [_c('b', [_vm._v("英文指令")]), _vm._v(" " + _vm._s(_vm.current.instructionEn))]) : _vm._e(), _vm._v(" "), (_vm.current.script) ? _c('p', [_c('b', [_vm._v("脚本")]), _vm._v(" " + _vm._s(_vm.current.script))]) : _vm._e(), _vm._v(" "), (_vm.current.passageText) ? _c('p', [_c('b', [_vm._v("篇章")]), _vm._v(" " + _vm._s(_vm.current.passageText))]) : _vm._e(), _vm._v(" "), (_vm.mediaSrc(_vm.current.passageImage)) ? _c('p', [_c('img', {
    staticClass: "mex-trial-img",
    attrs: {
      "src": _vm.mediaSrc(_vm.current.passageImage)
    }
  })]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "mex-trial-stem"
  }, [_vm._v(_vm._s(_vm.current.stem))]), _vm._v(" "), (_vm.mediaSrc(_vm.current.stemImage)) ? _c('p', [_c('img', {
    staticClass: "mex-trial-img",
    attrs: {
      "src": _vm.mediaSrc(_vm.current.stemImage)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.mediaSrc(_vm.current.stemAudio)) ? _c('p', [_c('audio', {
    attrs: {
      "src": _vm.mediaSrc(_vm.current.stemAudio),
      "controls": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isChoiceBlanks && _vm.blankView.length) ? _c('div', _vm._l((_vm.blankView), function(b) {
    return _c('div', {
      key: 'cz-' + b.no,
      staticClass: "mex-trial-opts",
      staticStyle: {
        "margin-bottom": "12px"
      }
    }, [_c('p', [_vm._v("第 " + _vm._s(b.no) + " 问 " + _vm._s(b.prompt))]), _vm._v(" "), _c('Radio-group', {
      model: {
        value: (b.value),
        callback: function($$v) {
          _vm.$set(b, "value", $$v)
        },
        expression: "b.value"
      }
    }, _vm._l(((b.options || [])), function(opt) {
      return _c('Radio', {
        key: b.no + '-' + opt.code,
        staticStyle: {
          "display": "block",
          "margin": "8px 0"
        },
        attrs: {
          "label": opt.code
        }
      }, [_vm._v("\n              " + _vm._s(opt.code) + ". " + _vm._s(opt.text) + "\n            ")])
    }), 1)], 1)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.isWordForm && _vm.optView.options.length) ? _c('div', {
    staticClass: "mex-trial-opts"
  }, [_c('p', [_c('b', [_vm._v("词库")]), _vm._v(" " + _vm._s(_vm.optView.options.map(function (o) { return o.text; }).filter(function (t) { return t; }).join(' / ')))])]) : _vm._e(), _vm._v(" "), (_vm.optView.mode === 'CHOICE' && !_vm.isChoiceBlanks && !_vm.isWordForm) ? _c('div', {
    staticClass: "mex-trial-opts"
  }, [_c('Radio-group', {
    model: {
      value: (_vm.draft.choice),
      callback: function($$v) {
        _vm.$set(_vm.draft, "choice", $$v)
      },
      expression: "draft.choice"
    }
  }, _vm._l((_vm.optView.options), function(opt) {
    return _c('Radio', {
      key: opt.code,
      staticStyle: {
        "display": "block",
        "margin": "8px 0"
      },
      attrs: {
        "label": opt.code
      }
    }, [_vm._v("\n            " + _vm._s(opt.code) + ". " + _vm._s(opt.text) + "\n            "), (_vm.mediaSrc(opt.image)) ? _c('img', {
      staticClass: "mex-trial-opt-img",
      attrs: {
        "src": _vm.mediaSrc(opt.image)
      }
    }) : _vm._e()])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.optView.mode === 'DRAG') ? _c('div', [_c('p', [_vm._v("可拖词块：" + _vm._s(_vm.optView.tokens.join(' / ')))]), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": "按正确顺序拼好后填在这里，如 ball 或 What do you need?"
    },
    model: {
      value: (_vm.draft.text),
      callback: function($$v) {
        _vm.$set(_vm.draft, "text", $$v)
      },
      expression: "draft.text"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.blankView.length && !_vm.isChoiceBlanks) ? _c('div', [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, _vm._l((_vm.blankView), function(b) {
    return _c('i-col', {
      key: b.no,
      attrs: {
        "span": (_vm.isFillBlanks || _vm.isWordForm) ? 24 : 8
      }
    }, [_c('p', [_vm._v("第 " + _vm._s(b.no) + " 空 " + _vm._s(b.prompt))]), _vm._v(" "), _c('Input', {
      attrs: {
        "placeholder": _vm.isFillBlanks ? '这一空的短语' : (_vm.isWordForm ? '这一空的词形，如 is coloring' : (b.prompt || '这一空的答案'))
      },
      model: {
        value: (b.value),
        callback: function($$v) {
          _vm.$set(b, "value", $$v)
        },
        expression: "b.value"
      }
    })], 1)
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.optView.mode !== 'CHOICE' && !_vm.blankView.length && _vm.optView.mode !== 'DRAG' && !_vm.isChoiceBlanks) ? _c('div', [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": _vm.answerPh
    },
    model: {
      value: (_vm.draft.text),
      callback: function($$v) {
        _vm.$set(_vm.draft, "text", $$v)
      },
      expression: "draft.text"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isSubjectiveWrite) ? _c('Checkbox', {
    model: {
      value: (_vm.draft.ocrConfirm),
      callback: function($$v) {
        _vm.$set(_vm.draft, "ocrConfirm", $$v)
      },
      expression: "draft.ocrConfirm"
    }
  }, [_vm._v("已确认识别内容（写作主观分需要）")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.scoring
    },
    on: {
      "click": function($event) {
        return _vm.submitCurrent(0)
      }
    }
  }, [_vm._v("提交本题")]), _vm._v(" "), _c('Button', {
    on: {
      "click": function($event) {
        return _vm.submitCurrent(1)
      }
    }
  }, [_vm._v("跳过（0分）")]), _vm._v(" "), _c('Button', {
    attrs: {
      "disabled": _vm.index === 0
    },
    on: {
      "click": _vm.prev
    }
  }, [_vm._v("上一题")]), _vm._v(" "), _c('Button', {
    attrs: {
      "disabled": _vm.index >= _vm.items.length - 1
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("下一题")])], 1), _vm._v(" "), (_vm.current.result) ? _c('div', {
    staticClass: "mex-trial-result"
  }, [_c('p', [_c('b', [_vm._v("判分")]), _vm._v(" " + _vm._s(_vm.current.result.score) + " / " + _vm._s(_vm.current.result.fullScore) + " · " + _vm._s(_vm.current.result.mastered === 1 ? '掌握' : '未掌握') + " · " + _vm._s(_vm.scorerLabel(_vm.current.result.scorer)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("你的作答")]), _vm._v(" " + _vm._s(_vm.current.result.payload || '（空）'))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("标准答案")]), _vm._v(" " + _vm._s(_vm.current.result.expected || '（空）'))]), _vm._v(" "), (_vm.current.result.note) ? _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v(_vm._s(_vm.current.result.note))]) : _vm._e()]) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.report) ? _c('div', {
    staticClass: "mex-trial-report"
  }, [_c('h3', [_vm._v("模拟家长报告")]), _vm._v(" "), _vm._l(((_vm.report.notes || [])), function(n, i) {
    return _c('p', {
      key: 'n' + i,
      staticClass: "mex-dim-hint"
    }, [_vm._v(_vm._s(n))])
  }), _vm._v(" "), _c('div', {
    staticClass: "mex-trial-report-hero"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.report.title || '—'))]), _vm._v(" · " + _vm._s(_vm.report.medalLabel || '—') + " · 百分制 " + _vm._s(_vm.report.totalScore))]), _vm._v(" "), _c('p', [_vm._v("\n        " + _vm._s(_vm.report.examType === 'SUMMATIVE' ? '阶段测' : '入门测') + "\n        · " + _vm._s(_vm.placementPublishLine(_vm.report)) + "\n        · 升班 " + _vm._s(_vm.report.promotionLabel || '—') + "\n        · 年龄档 " + _vm._s(_vm.ageBandLabel(_vm.report.ageBand)) + "\n      ")]), _vm._v(" "), (_vm.report.examType === 'PLACEMENT') ? _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("\n        触达 " + _vm._s(_vm.report.visitedMaxLevel || '—') + "\n        · 候选 " + _vm._s(_vm.report.candidateLevel || '—') + "\n        · 已验证 " + _vm._s(_vm.report.confirmedLevel || '—') + "\n        · 规则 " + _vm._s(_vm.report.ruleVersion || '—') + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('h4', [_vm._v("听说读写")]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.skillColumns,
      "data": _vm.report.skills || [],
      "size": "small"
    }
  }), _vm._v(" "), _c('h4', [_vm._v("学习建议")]), _vm._v(" "), _c('p', {
    staticClass: "mex-trial-advice"
  }, [_vm._v(_vm._s(_vm.report.advice || '暂无'))])], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e7b4634","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mex/MexTrialPaper.vue
// module id = 1837
// module chunks = 8